import unescapedText from 'I18n/utils/unescapedText';
import * as SupportSource from 'marketplace-ui-common/constants/search/SupportSource';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { useMemo } from 'react';

// @ts-expect-error module is untyped
import { getSupportSourceFilterI18nKey } from '../../../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ALL = 'ALL';
const supportOrder = [ALL, SupportSource.HUBSPOT, SupportSource.APP_PARTNER];
function getSupportSourceText(value) {
  const key = value === ALL ? 'appMarketplace.storefront.filters.supportSource.items.all' : getSupportSourceFilterI18nKey(value);
  return unescapedText(key);
}
function getOptions() {
  return supportOrder.map(supportSource => ({
    text: getSupportSourceText(supportSource),
    value: supportSource
  }));
}
function SupportSourceFilter({
  onChange,
  value
}) {
  const options = useMemo(() => getOptions(), []);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.supportSource.titleText'),
    name: "support-source",
    onChange: event => onChange(syntheticEvent(event.target.value === ALL ? null : event.target.value, event)),
    options: options,
    value: value || ALL
  });
}
export default SupportSourceFilter;